import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "bubble"]

  connect() {
    this._onDocPointer = (e) => { if (!this.element.contains(e.target)) this.hide() }
    this._reposition = () => { if (this.shown) this.position() }
  }

  disconnect() {
    this._teardown()
  }

  pointerEnter(event) {
    if (event.pointerType === "mouse") this.show()
  }

  pointerLeave(event) {
    if (event.pointerType === "mouse") this.hide()
  }

  toggle(event) {
    event.preventDefault()
    this.shown ? this.hide() : this.show()
  }

  show() {
    if (this.shown) return
    this.bubbleTarget.classList.remove("hidden")
    this.shown = true
    this.position()
    document.addEventListener("pointerdown", this._onDocPointer, true)
    window.addEventListener("scroll", this._reposition, true)
    window.addEventListener("resize", this._reposition)
  }

  hide() {
    if (!this.shown) return
    this.bubbleTarget.classList.add("hidden")
    this.shown = false
    this._teardown()
  }

  position() {
    const t = this.triggerTarget.getBoundingClientRect()
    const b = this.bubbleTarget
    const pad = 8
    const vw = document.documentElement.clientWidth
    const w = b.offsetWidth
    let left = Math.min(t.left, vw - w - pad)
    left = Math.max(pad, left)
    let ox = 0
    let oy = 0
    const cb = this.containingBlock()
    if (cb) {
      const r = cb.getBoundingClientRect()
      ox = r.left
      oy = r.top
    }
    b.style.top = `${Math.round(t.bottom + 6 - oy)}px`
    b.style.left = `${Math.round(left - ox)}px`
  }

  containingBlock() {
    let el = this.bubbleTarget.parentElement
    while (el && el !== document.documentElement) {
      const s = getComputedStyle(el)
      if (s.transform !== "none" || s.perspective !== "none" || s.filter !== "none") return el
      el = el.parentElement
    }
    return null
  }

  _teardown() {
    document.removeEventListener("pointerdown", this._onDocPointer, true)
    window.removeEventListener("scroll", this._reposition, true)
    window.removeEventListener("resize", this._reposition)
  }
}
